import * as React from 'react';
import { useDocumentTitle } from 'Document';
import { Locale, localize } from 'Locale';

export const NotFound: React.FunctionComponent<{locale: Locale}> = ({locale}) => {
	const title = localize(locale, 'Page Not Found');
	useDocumentTitle(title);
	return <>{title}</>;
};
